import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconPolygonOrangeSizeS from './IconPolygonOrange_size_s';

const props: CreateIconArguments = {
  l: IconPolygonOrangeSizeS,
  m: IconPolygonOrangeSizeS,
  s: IconPolygonOrangeSizeS,
  xs: IconPolygonOrangeSizeS,
  name: 'IconPolygonOrange',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
